module.exports = __webpack_public_path__ + "static/media/Experience.3825ea2c.webp";